/**
 * @Author: Li, Yu Jia
 * @Date: 2020-01-13 11:37:08
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2020-09-02 15:32:19
 * @Usage: userimage.apis.func
 */

import { get, post } from '../utils/request';

/**
 *@param StudioItemType - 0:Scene7; 1:Digital; 2:ScreenPrintedDigital
 *@param MaxColorCount: default 0 for Digital product, maxColorCount is only used for Scene7(StudioItemType:0) and ScreenPrintedDigital(StudioItemType:2)
 */

const getSloganList = (imprintAreaCode, vendorId) => {
  return get(`/api/v1/slogan?imprintAreaCode=${imprintAreaCode}&vendorId=${vendorId}`);
};
const getNewSloganList = (imprintAreaCode, vendorId) => {
  return get(`/api/v1/slogan/NewSlogan?imprintAreaCode=${imprintAreaCode}&vendorId=${vendorId}`);
};
const getStockArtCategories = (vendorId, studioItemType, maxColorCount = 0) => {
  return get(
    `/api/v1/StockArtCategory?vendorId=${vendorId}&studioItemType=${studioItemType}&maxColorCount=${maxColorCount}`
  );
};

/**
 *@param MaxColorCount: default 0 for Digital product, maxColorCount is only used for Scene7(StudioItemType:0) and ScreenPrintedDigital(StudioItemType:2)
 */
const getStockArtListByCategory = (vendorId, categoryId, studioItemType, maxColorCount = 0) => {
  return get(
    `/api/v1/StockArt?vendorId=${vendorId}&categoryId=${categoryId}&studioItemType=${studioItemType}&maxColorCount=${maxColorCount}`
  );
};

/**
 *@param MaxColorCount: default 0 for Digital product, maxColorCount is only used for Scene7(StudioItemType:0) and ScreenPrintedDigital(StudioItemType:2)
 */
const getStockArtListBySearch = (vendorId, keywords, studioItemType, maxColorCount = 0) => {
  return get(
    `/api/v1/StockArtSearch?vendorId=${vendorId}&keywords=${keywords}&studioItemType=${studioItemType}&maxColorCount=${maxColorCount}`
  );
};

const getSavedArtListByPage = (processType, imprintAreaCode, pageIndex, pageSize) => {
  return get(
    `/api/v1/SavedArt?processType=${processType}&imprintAreaCode=${imprintAreaCode}&pageIndex=${pageIndex}&pageSize=${pageSize}`
  );
};

const getSavedArtCount = (processType, imprintAreaCode) => {
  return get(`/api/v1/SavedArtCount?processType=${processType}&imprintAreaCode=${imprintAreaCode}`);
};

const getSavedArtPreview = (fileName, processType, imprintAreaCode) =>
  get(`/api/v1/SavedArtPreview?fileName=${fileName}&processType=${processType}&imprintAreaCode=${imprintAreaCode}`);

const getSharedArtList = (vendorId, itemId, processType, currentImprintAreaCode) => {
  return get(
    `/api/v1/SharedArt?vendorId=${vendorId}&itemId=${itemId}&processType=${processType}&currentImprintAreaCode=${currentImprintAreaCode}`
  );
};
const getSavedArtDimension = (vendorId, fileName, processType, imprintAreaCode) =>
  get(
    `/api/v1/SavedArtDimension?vendorId=${vendorId}&fileName=${fileName}&processType=${processType}&imprintAreaCode=${imprintAreaCode}`
  );

const getVerseList = (itemId) => {
  return get(`/api/v1/verse?itemId=${itemId}`);
};

const getSentimentList = (itemId) => {
  return get(`/api/v1/sentiment?itemId=${itemId}`);
};

const getColorsFromColorizeService = (checkColorRequest) =>
  post(`/api/v1/Colorize/ColorizeCheckColor`, checkColorRequest);

export {
  getNewSloganList,
  getSloganList,
  getStockArtCategories,
  getStockArtListByCategory,
  getStockArtListBySearch,
  getSavedArtListByPage,
  getSavedArtCount,
  getSavedArtPreview,
  getSharedArtList,
  getSavedArtDimension,
  getVerseList,
  getSentimentList,
  getColorsFromColorizeService,
};
